import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import {
  ContractsBankHolidayTreatmentEnum,
  DataSchemaItemFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/employees/components/UnifiedAddEmployeeModal/types'
import { WorkingConditions } from 'modules/job_catalog/lib/workingConditions'

import MatchingValueTooltip from './MatchingValueTooltip'
import { useWorkingConditionsInitialValue } from './workingConditions'

interface Props {
  field: DataSchemaItemFragment
  fieldName: keyof WizardData
  data: WizardData
  isExistingUser?: boolean
  onChangeField: (fieldName: string, value: string) => void
  workingConditions?: WorkingConditions
}

export const BankHolidayTreatmentField = ({
  fieldName,
  field,
  data,
  onChangeField,
  workingConditions,
}: Props) => {
  const initialValue = useWorkingConditionsInitialValue(
    field,
    fieldName,
    data,
    onChangeField,
    workingConditions
  )

  const bankHolidayTreatmentOptions: {
    label: string
    value: ContractsBankHolidayTreatmentEnum
  }[] = [
    {
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.non_workable'
      ),
      value: 'non_workable',
    },
    {
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.workable'
      ),
      value: 'workable',
    },
  ]

  return (
    <Box gap="s8">
      <Box gap="s2">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t(
            'add_employee_modal.contract_information_step.fields.bank_holidays_tratment.label'
          )}
        </Text.Normal>
      </Box>
      <Box gap="s8">
        {bankHolidayTreatmentOptions.map((option) => {
          return (
            <Box key={option.value} position="relative">
              <RadioButton
                label={option.label}
                size="small"
                onChange={() => onChangeField(fieldName, option.value)}
                value={data.contractsBankHolidayTreatment || ''}
                checked={
                  data[fieldName] === option.value ||
                  (data[fieldName] === undefined && option.value === 'non_workable')
                }
              />
              {data[fieldName] === option.value && initialValue && (
                <Box position="absolute" style={{ right: '38px' }}>
                  <MatchingValueTooltip
                    type="workingCondition"
                    linked={data[fieldName] === initialValue}
                    onClick={() => onChangeField(fieldName, initialValue || '')}
                    workingConditionName={workingConditions?.name}
                  />
                </Box>
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
